const NA_NUMBERS = ['0400000000', '+61400000000'];

export const replaceDefaultPhone = (ph: string) => {
  if (NA_NUMBERS.includes(ph.replaceAll(' ', ''))) {
    return 'N/A';
  }
  return ph;
};
